export default __webpack_public_path__ + "static/media/chorizo.b889a568.png";